export default "__VITE_ASSET__Chq0qaG1__"